/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import React from 'react';
import { ButtonChevronIcon } from 'src/domains/layouts/shared/ScrollButtons.style';
import { DirectionType } from 'src/domains/casino/webview/CasinoGames/home-games/casino-banners/CasinoBanners';
import {
    ScrollLeft,
    ScrollRight,
} from 'src/domains/casino/webview/CasinoGames/home-games/casino-banners/BannerArrow.style';

interface BannerArrowPropsType {
    slideInDirection: (direction: DirectionType) => void;
    direction: DirectionType;
}

export const BannerArrow = (props: BannerArrowPropsType): JSX.Element => {
    const { slideInDirection, direction } = props;
    return (
        <>
            {direction === 'left' && (
                <ScrollLeft
                    isVisible={direction === 'left'}
                    onClick={(): void => slideInDirection(direction)}
                    data-test='casino-banner-left-arrow'
                >
                    <ButtonChevronIcon position='left' />
                </ScrollLeft>
            )}
            {direction === 'right' && (
                <ScrollRight
                    isVisible={direction === 'right'}
                    onClick={(): void => slideInDirection(direction)}
                    data-test='casino-banner-right-arrow'
                >
                    <ButtonChevronIcon position='right' />
                </ScrollRight>
            )}
        </>
    );
};
